import * as React from "react";
import Header from "../Header";
import Content from "./Content";
import PageContextProvider from "./PageContext";
import SpeedDealActions from "./SpeedDealActions";

const Page = ({
  asyncDataProps,
  analytics,
  title,
  isSpeedDealMenuOpened,
  isFooterHidden,
  headerMenuActions,
  speedDealActions,
  backgroundImage,
  backgroundOpacity,
  children,
  pathname,
  onSwitchTheme,
  onOpenCloseSpeedDeals
}) => {
  return /*#__PURE__*/React.createElement(PageContextProvider, {
    title: title,
    isSpeedDealMenuOpened: isSpeedDealMenuOpened,
    isFooterHidden: isFooterHidden,
    backgroundImage: backgroundImage,
    backgroundOpacity: backgroundOpacity,
    headerMenuActions: headerMenuActions,
    speedDealActions: speedDealActions
  }, /*#__PURE__*/React.createElement(Header, {
    pathname: pathname,
    onSwitchTheme: onSwitchTheme
  }), /*#__PURE__*/React.createElement(Content, {
    asyncDataProps: asyncDataProps,
    analytics: analytics
  }, children), /*#__PURE__*/React.createElement(SpeedDealActions, {
    onOpenClose: onOpenCloseSpeedDeals
  }));
};

export default Page;